import { api } from 'services/companiesApi';
import { Doctor, GetPersonalTypeParams } from './DoctorDrawer.types';

export const postDoctor = async (data: Doctor) => {
	return await api.post('/doctors', data);
};

export const putDoctor = async (id: string, data: Doctor) => {
	return await api.put(`/doctors/${id}`, data);
};

export const patchDoctorStatus = async (id: string, active: boolean) => {
	return await api.patch(`/doctors/${id}/status`, { active });
};

export const getSpecialties = async () => {
	return await api.get('/doctors/specialties');
};

export const getPersonalTypes = async (filters: GetPersonalTypeParams) => {
	return await api.get('/me/personal-types', { params: filters });
};

export const getDoctorBranchOffices = async (
	doctorId: string,
	name?: string,
) => {
	return await api.get(
		`/access-management/doctors/${doctorId}/branch-offices`,
		{
			params: name ? { name } : undefined,
		},
	);
};
